import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToolbarReadyService {
  private _toolbarReady = new BehaviorSubject<boolean>(false);
  public toolbarReady$ = this._toolbarReady.asObservable();

  setReady(): void {
    this._toolbarReady.next(true);
  }
}
